export const defaultInvalidRedemptionSubCode = 103806;
export const invalidRedemptionSubCodeList = [
  103801, 103802, 103803, 103804, 103805, 103806,
];
